import React, {Component} from 'react';
import {withNamespaces} from "react-i18next";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import DiagnosticModeButton from "../../../components/DiagnosticModeButton";
import {Alert, Col, Nav, Row, Spinner, Tab} from "react-bootstrap";
import {connect} from "react-redux";
import {networkDeviceContentActions} from "../../../actions/network-device-content.actions";
import {networkDeviceActions} from "../../../actions/network-device.actions";
import ConnectionStatus from "../../../components/ConnectionStatus";
import NetworkDeviceContentTable from "./_components/NetworkDeviceContentTable";
import {Link} from "react-router-dom";
import {claimTypes} from "../../../constants/claim.constants";
import {exhibitionScenarioActions} from "../../../actions/exhibition-scenario.actions";
import NetworkDeviceContentScenarioList from "./_components/NetworkDeviceContentScenarioList";
import {userHelper} from "../../../helpers/user-helper";
import SimpleConnectionStatus from "../../../components/SimpleConnectionStatus";

class NetworkDeviceContentPage extends Component {

    componentDidMount() {
        const id = this.props.match.params.id;
        const { dispatch } = this.props;
        dispatch(networkDeviceActions.getNetworkDeviceSimpleInfo(id));
        dispatch(exhibitionScenarioActions.getDropdownListExhibitionScenario());
        this.updateStore();
    }

    componentWillUnmount() {
        const { dispatch, history } = this.props;
        const pathName = history.location.pathname;

        if(history.action === "PUSH" && !(pathName.includes('create') || pathName.includes('edit' ))) {
            dispatch(networkDeviceContentActions.clearStore());
        }

        if(this.interval) {
            clearInterval(this.interval);
        }
    }

    updateStore = () => {
        const id = this.props.match.params.id;
        const { dispatch } = this.props;
        dispatch(networkDeviceContentActions.getNetworkDeviceContentById(id, false));
        if(!this.interval) {
            this.interval = setInterval(this.updateStore, 5000);
        }
    };


    render() {
        const { t, currentNetworkDeviceContent, exhibitionScenarioDropdown, simpleDeviceInfo, loader, loaderMsg, user } = this.props;

        const diagnosticModePermission      = user[`c_network-device.actions.diagnostic-mode`] || null;
        const networkDeviceContentCrud      = user[`c_network-device-content.actions.crud`] || null;

        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: 'network-device-content', path: '#' },
            { value: simpleDeviceInfo?.label, path: '#' },
        ];

        // using scenario
        const useScenario = userHelper.getUseExhibitionScenario(user) && simpleDeviceInfo?.useScenario;

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <div className="row">
                    <div className="col-md-3">
                        <h3>{t('content-on-device')}</h3>
                        <h5 className='font-italic'>{simpleDeviceInfo?.label}</h5>

                        { diagnosticModePermission === claimTypes.READ_WRITE ? (
                            <div id="diagnosticModeBox" className="card">
                                <div className="card-body">
                                    { simpleDeviceInfo  ? (<DiagnosticModeButton networkDevice={simpleDeviceInfo} reloadSimpleModel={true} />) : (<Spinner animation={"grow"} />)}
                                </div>
                            </div>
                        ) : (<React.Fragment/>) }
                    </div>

                    <div className="col-md-9">
                        <ul>
                            <li className="list-group-item">{t('type')} : <b>{ simpleDeviceInfo?.deviceType.label }</b></li>
                            <li className="list-group-item">{t('ip-address')} : <b>{ simpleDeviceInfo?.ipAddress }</b></li>
                            <li className="list-group-item">{t('mac')} : <b>{ simpleDeviceInfo?.mac }</b></li>
                            <li className="list-group-item">
                                <SimpleConnectionStatus className="float-left" status={simpleDeviceInfo?.isOnline } translateKey="status-hilight" boldDesc={true}/>
                            </li>
                            <li className="list-group-item">
                                <SimpleConnectionStatus className="float-left" status={simpleDeviceInfo?.isOnlineNetwork } translateKey="status-network" boldDesc={true} />
                            </li>
                        </ul>
                    </div>

                    <div className="col-md-12 mt-3" hidden={simpleDeviceInfo === null}>
                        { simpleDeviceInfo?.diagnosticMode ? (
                            <Alert variant={"success"}>
                                <div dangerouslySetInnerHTML={{ __html: `<i class="fas fa-info"> </i> &nbsp; ${t('content-diagnostic-mode-on-msg')} `}} />
                            </Alert>
                        ) : (
                            <Alert variant={"warning"}>
                                <div dangerouslySetInnerHTML={{ __html: `<i class="fas fa-info"> </i> &nbsp; ${t('content-diagnostic-mode-off-msg')} `}} />
                            </Alert>
                        ) }
                    </div>
                </div>

                { !loader ? (
                    <div className="card">
                        <div className="card-header">
                            <div className="button-group float-left">
                                <Link className="btn btn-info mx-2" to={`/panel/network-device/content/${simpleDeviceInfo?.id}/logs`}>
                                    <i className="fas fa-file-alt" /> &nbsp; { t('content-activity-log') }
                                </Link>

                            </div>
                            <div className="button-group float-right">
                                <Link to="/panel/network-device" className="btn btn-secondary">
                                    <i className="fas fa-undo"> </i> {t('back-to-list')}
                                </Link> &nbsp;

                                { simpleDeviceInfo?.diagnosticMode && networkDeviceContentCrud === claimTypes.READ_WRITE ? (
                                    <Link to={"/panel/network-device/content/" + simpleDeviceInfo?.id + "/create"} className="btn btn-success">
                                        <i className="fas fa-plus"> </i> {t('create')}
                                    </Link>
                                ) : (<React.Fragment/>) }

                            </div>
                        </div>
                        <div className="card-body">
                            { simpleDeviceInfo ?
                                useScenario ? (
                                    <NetworkDeviceContentScenarioList
                                        scenarioList={exhibitionScenarioDropdown}
                                        networkDeviceContentList={currentNetworkDeviceContent}
                                        deviceInfo={simpleDeviceInfo}
                                    />
                                ) : (
                                    <NetworkDeviceContentTable list={currentNetworkDeviceContent} device={simpleDeviceInfo}/>
                                )
                            : (
                                <Spinner animation={"border"} size={"lg"} />
                            )}
                        </div>
                    </div>
                ) : (
                    <Alert variant={"warning"}>
                        <h4>{t(loaderMsg)}</h4>
                        <Spinner animation={"border"} />
                    </Alert>
                )}

            </div>
        )
    }
}

const mapStateToProps = (state) => {
  const { currentNetworkDeviceContent } = state.networkDeviceContentReducer;
  const { simpleDeviceInfo, loader, loaderMsg } = state.networkDeviceReducer;
  const { exhibitionScenarioDropdown } = state.exhibitionScenarioReducer;
  const { user } = state.authenticationReducer;
  return {
      currentNetworkDeviceContent,
      simpleDeviceInfo,
      exhibitionScenarioDropdown,
      loader,
      loaderMsg,
      user
  }
};

export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceContentPage));
